// services.ts
import { apiClient } from "queries/constants";
import {
  AuthUserRoomMembership,
  CreateDMRoomResponse,
  LegacyRoom,
  ListRoomsResponse,
  MentionableModel,
  Room,
  RoomResponse,
} from "./types";

interface CreateRoomResponse {
  room: Room;
}

const createRoom = async (data: Partial<Room>) => {
  const response = await apiClient.post<CreateRoomResponse>(
    "v1/createRoom",
    data
  );
  return response.data.room;
};

const createDMRoom = async (data: { invitedUserIDs: string[] }) => {
  const response = await apiClient.post<CreateDMRoomResponse>(
    "v1/createDMRoom",
    data
  );
  return response.data;
};

const updateRoom = async (roomID: string, data: Partial<Room>) => {
  const response = await apiClient.post<Room>(`v1/updateRoom`, {
    roomID,
    ...data,
  });
  return response.data;
};

const joinRoom = async (roomID: string) => {
  const response = await apiClient.post<AuthUserRoomMembership>(`v1/joinRoom`, {
    roomID,
  });
  return response.data;
};

const leaveRoom = async (roomID: string) => {
  const response = await apiClient.post<{ ok: boolean }>(`v1/leaveRoom`, {
    roomID,
  });
  return response.data;
};

const updateUserRoomMembership = async (data: {
  roomID: string;
  userHasAcknowledged?: true;
  roomIsHidden?: true;
  lastMessageReadTSStr?: Date;
}) => {
  const response = await apiClient.post<AuthUserRoomMembership>(
    `v1/updateUserRoomMembership`,
    data
  );
  return response.data;
};

const updateLegacyRoom = async (roomID: string, data: Partial<LegacyRoom>) => {
  const response = await apiClient.post<LegacyRoom>(`v1/updateLegacyRoom`, {
    roomID,
    ...data,
  });
  return response.data;
};

const getRoom = async (roomID: string) => {
  const response = await apiClient.get<RoomResponse>(
    "v1/getRoom" + "?roomID=" + roomID
  );
  return response.data;
};

const listRooms = async () => {
  const response = await apiClient.get<ListRoomsResponse>("v1/listRooms");
  return response.data;
};

const listCuratedRooms = async () => {
  const response = await apiClient.get<{ rooms: Room[] }>(
    "v1/listCuratedRooms"
  );
  return response.data;
};

// @deprecated Rocky disabled this endpoint server-side (heavy DB cost, results
// were low-signal in large rooms with many same-named users). Mention pickers
// now source candidates locally from observed message authors — see
// `ui/components/chat/lib/mentionable-store` and PR #1970.
const listRoomActionsV2 = async (roomID: string, searchStr?: string) => {
  const response = await apiClient.get<{ mentionables: MentionableModel[] }>(
    "v1/listRoomActionsV2",
    {
      params: {
        roomID,
        searchStr,
      },
    }
  );
  return response.data;
};

export {
  createDMRoom,
  createRoom,
  getRoom,
  joinRoom,
  leaveRoom,
  listCuratedRooms,
  listRoomActionsV2,
  listRooms,
  updateLegacyRoom,
  updateRoom,
  updateUserRoomMembership,
};
